module.exports = __webpack_public_path__ + "img/winning_form-logo_black.f3423d85.png";